export default __webpack_public_path__ + "static/thehairlabel-828e5673243e3a9e0cbceb7bc3eb6318.png";